import React, { useEffect, useRef, useState } from "react";
import classes from "../MasterDashboard.module.css";

const normalizeOptions = (options) =>
  options.map((opt) => (typeof opt === "string" ? { value: opt, label: opt } : opt));

const optionDisplayLabel = (opt) => (opt.code ? `${opt.label} | ${opt.code}` : opt.label);

const FilterSelect = ({ label, value, onChange, options }) => (
  <div className={classes.filterGroup}>
    <span className={classes.filterLabel}>{label}</span>
    <select
      className={classes.filterSelect}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {normalizeOptions(options).map((opt) => (
        <option key={opt.value} value={opt.value} title={optionDisplayLabel(opt)}>
          {optionDisplayLabel(opt)}
        </option>
      ))}
    </select>
  </div>
);

export const InlineFilterSelect = ({ label, value, onChange, options }) => {
  const normalized = normalizeOptions(options);
  const selected = normalized.find((opt) => opt.value === value);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className={classes.inlineFilterGroup} ref={containerRef}>
      {label && <span className={classes.inlineFilterLabel}>{label}</span>}
      <div className={classes.customSelectWrapper}>
        <button
          type="button"
          className={classes.inlineFilterSelect}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className={classes.customSelectValue}>
            {selected ? optionDisplayLabel(selected) : value}
          </span>
          <i className={`fa fa-chevron-down ${classes.customSelectCaret}`}></i>
        </button>
        {open && (
          <ul className={classes.customSelectMenu}>
            {normalized.map((opt) => (
              <li
                key={opt.value}
                className={`${classes.customSelectOption} ${opt.value === value ? classes.customSelectOptionActive : ""}`}
                title={optionDisplayLabel(opt)}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
              >
                {optionDisplayLabel(opt)}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FilterSelect;
